import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';
import PropTypes from 'prop-types';

export function ContentBody({ text }) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      className="[word-break:break-word]"
    >
      {text}
    </ReactMarkdown>
  );
}

ContentBody.propTypes = {
  text: PropTypes.string.isRequired,
};
